import { render, staticRenderFns } from "./PosDocument.vue?vue&type=template&id=7e5f0667&"
import script from "./PosDocument.vue?vue&type=script&lang=js&"
export * from "./PosDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports